import React from "react";
import Header from "../Header/Header";

import { Box, useTheme } from "@mui/material";

import { boxStyles, mainStyles } from "./Layout.styles";

const Layout = ({ children }) => {
  const theme = useTheme();

  return (
    <Box sx={boxStyles}>
      <Header />

      <Box
        component="main"
        sx={{
          ...mainStyles,
          backgroundColor: theme.palette.background.default,
        }}
      >
        {children}
      </Box>
      
    </Box>
  );
};

export default Layout;
